/* eslint-disable import/no-anonymous-default-export */
/**
 * 블로그 상품 신청 캠페인 설정
 */
import RefundBadge from "../components/RefundBadge";
export default {
  id: "adBlog",
  title: "블로그 상품 신청",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/blogs",
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/blogs/count",
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/blogs/submitted",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/blogs/paid",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/blogs/complete",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/refund",
      version: 2,
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/blogs",
    },
  },

  filters: {
    default: {
      status: "전체",
      submitDate: "",
      keyword: "",
      page: 1,
      limit: 50,
      submitted: "전체",
      paid: "전체",
      productTypes: [],
    },
    schema: [
      {
        name: "productTypes",
        label: "상품 타입",
        type: "checkbox-group",
        options: [
          { value: "blog_press_corps", label: "비실계 배포" },
          { value: "blog_writing", label: "최적블 원고" },
          { value: "realname_reviewers", label: "실명 기자단" },
          { value: "seo_corps_distribution", label: "최적블 배포" },
          { value: "blog_distribution_without_photo", label: "사진필요없는 블로그배포" },
        ],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 플레이스명",
      },
      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "처리중" },
          { value: "completed", label: "종료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "처리중" },
      { key: "completedCount", label: "종료" },
    ],
  },

  table: {
    keyField: "adBlogId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.userName}
              {row.userId ? ` (${row.userId})` : ""}
            </div>
            <div>
              <span className={`badge badge-${row.status}`}>{getStatusLabel(row.status)}</span>
            </div>
          </>
        ),
      },
      {
        key: "submitDate",
        label: "접수일",
        center: true,
      },
      {
        key: "type",
        label: "상품타입\n총수량(일수량/진행일)\n총금액(단가)",
        center: true,
        render: (row) => {
          const productTypes = [
            { value: "blog_press_corps", label: "비실계 배포" },
            { value: "blog_writing", label: "최적블 원고" },
            { value: "realname_reviewers", label: "실명 기자단" },
            { value: "seo_corps_distribution", label: "최적블 배포" },
            { value: "blog_distribution_without_photo", label: "사진필요없는 블로그배포" },
          ];
          const getProductTypeLabel = (type) => {
            const productType = productTypes.find((pt) => pt.value === type);
            return productType ? productType.label : type;
          };

          return (
            <>
              <div>{getProductTypeLabel(row.type)}</div>
              <div>
                {row.postCount}건 ({row.dailyPostCount}건/{row.progressDays}일)
              </div>
              <div>
                {row.totalAmount?.toLocaleString()}원 (
                {Math.round(row.totalAmount / 1.1 / row.postCount)?.toLocaleString()}원)
              </div>
            </>
          );
        },
      },
      {
        key: "placeName",
        label: "플레이스명\n연락처\n플레이스URL",
        center: true,
        render: (row) => (
          <>
            <div>{row.placeName}</div>
            <div>{row.phoneNum || "-"}</div>
            <div>
              {row.placeUrl && (
                <a href={row.placeUrl} target="_blank" rel="noopener noreferrer">
                  {row.placeUrl}
                </a>
              )}
            </div>
          </>
        ),
      },
      {
        key: "keywords",
        label: "언더키워드\n제외키워드(선택)\n강조키워드\n해시태그(선택)",
        center: true,
        render: (row) => (
          <>
            <div>{row.isUnderKeyword === 1 ? "언더키워드" : "-"}</div>
            <div>{row.excludedKeywords || "-"}</div>
            <div>{row.emphasizedKeywords || "-"}</div>
            <div>{row.hashtags || "-"}</div>
          </>
        ),
      },
      {
        key: "guideline",
        label: "가이드라인\n사진설명(선택)",
        center: true,
        render: (row) => (
          <>
            <div className="guideline-textbox" title={row.guideline || "-"} data-blog-id={row.adBlogId}>
              {row.guideline || "-"}
            </div>
            <div className="guideline-textbox photo-description-textbox" data-photo-blog-id={row.adBlogId}>
              {Array.isArray(row.photoDescription) && row.photoDescription.length ? row.photoDescription[0] : "-"}
            </div>
          </>
        ),
      },
      {
        key: "paymentType",
        label: "결제방법\n결제상태",
        center: true,
        render: (row) => (
          <>
            <div>{row.paymentType === "card" ? "카드" : row.paymentType === "v_bank" ? "가상계좌" : row.paymentType === "point" ? "포인트 결제" : "계좌이체"}</div>
            <div>
              {row.isPaid === 2 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}>
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row) => (
          <button
            type="button"
            className="status-btn submitted"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-type={row.type}
            data-place-name={row.placeName || ""}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡",
        center: true,
        render: (row) => {
          const productTypes = [
            { value: "blog_press_corps", label: "비실계 배포" },
            { value: "blog_writing", label: "최적블 원고" },
            { value: "realname_reviewers", label: "실명 기자단" },
            { value: "seo_corps_distribution", label: "최적블 배포" },
            { value: "blog_distribution_without_photo", label: "사진필요없는 블로그배포" },
          ];
          const getProductTypeLabel = (type) => {
            const productType = productTypes.find((pt) => pt.value === type);
            return productType ? productType.label : type;
          };
          const productName = getProductTypeLabel(row.type) || "블로그 상품 신청";

          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={row.totalAmount ?? ""}
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo
              ? <span className="memo-preview">{row.memo}</span>
              : "메모"}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수/취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const hasUnsubmitted = items.some((item) => selectedIds.includes(item.adBlogId) && item.isSubmitted !== 1);
        return {
          adBlogIds: selectedIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some((item) => selectedIds.includes(item.adBlogId) && item.isPaid === 1);
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds) => ({
        adBlogIds: selectedIds,
        toggleValue: 1,
      }),
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) => selectedIds.includes(item.adBlogId) && (item.isPaid === 1 || item.isPaid === 2) && (item.remainingAmount ?? item.totalAmount ?? 0) > 0
        );
      },
    },
    {
      id: "complete",
      label: "완료/취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: (selectedIds, items) => {
        const hasUncompleted = items.some((item) => selectedIds.includes(item.adBlogId) && item.isCompleted !== 1);
        return hasUncompleted
          ? "선택한 블로그 신청을 완료 처리하시겠습니까?"
          : "선택한 블로그 신청을 취소 처리하시겠습니까?";
      },
      payloadBuilder: (selectedIds, items) => {
        const hasUncompleted = items.some((item) => selectedIds.includes(item.adBlogId) && item.isCompleted !== 1);
        return {
          adBlogIds: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      confirm: "선택한 블로그 신청을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds) => ({
        adBlogIds: selectedIds,
      }),
    },
  ],

  download: {
    type: "xlsx",
    fileName: "블로그상품_신청목록.xlsx",
    sheetName: "블로그상품신청목록",
    transformRow: (row) => {
      const productTypes = [
        { value: "blog_press_corps", label: "비실계 배포" },
        { value: "blog_writing", label: "최적블 원고" },
        { value: "realname_reviewers", label: "실명 기자단" },
        { value: "seo_corps_distribution", label: "최적블 배포" },
        { value: "blog_distribution_without_photo", label: "사진필요없는 블로그배포" },
      ];

      const getProductTypeLabel = (type) => {
        const productType = productTypes.find((pt) => pt.value === type);
        return productType ? productType.label : type;
      };

      return {
        신청자: row.userName || "",
        접수일: row.submitDate || "",
        상품타입: getProductTypeLabel(row.type),
        일수량: row.dailyPostCount || 0,
        진행일: row.progressDays || 0,
        총수량: row.postCount || 0,
        총금액: row.totalAmount || 0,
        단가: Math.round(row.totalAmount / 1.1 / row.postCount) || 0,
        플레이스명: row.placeName || "",
        연락처: row.phoneNum || "",
        플레이스URL: row.placeUrl || "",
        영상첨부유무: row.videoAttached === "Y" ? "첨부" : "미첨부",
        강조키워드: row.emphasizedKeywords || "",
        제외키워드: row.excludedKeywords || "",
        해시태그: row.hashtags || "",
        가이드라인: row.guideline || "",
        사진설명: Array.isArray(row.photoDescription) && row.photoDescription.length
          ? row.photoDescription.map((item, i) => `${i + 1}. ${item}`).join("\n")
          : "",
      };
    },
  },
};

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "처리중";
    case "completed":
      return "종료";
    default:
      return status;
  }
}
